import { Box, CircularProgress } from "@mui/material";
import { FunctionComponent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TokenUserHelper } from "../common/services/token-user-service";
import { CommonConstants } from "../common/constants/common-constants";

export const Home: FunctionComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const tokenUser = TokenUserHelper.Get();
    if (tokenUser === undefined || Object.keys(tokenUser).length === 0) {
      navigate("/user/login");
    } else if (tokenUser.UserType === CommonConstants.UserType.School) {
      navigate("/school/Home");
    } else if (tokenUser.UserType === CommonConstants.UserType.Admin) {
      navigate('/Facilitator/sharedfiles');
    }
  }, [navigate]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <CircularProgress />
    </Box>
  );
};
